import React from "react";
import { connect } from "react-redux";
import { CSVLink } from "react-csv";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import FilterListIcon from "@material-ui/icons/FilterList";
import InsertDriveFile from "@material-ui/icons/InsertDriveFile";
import TemporaryDrawer from "../drawer/TemporaryDrawer";
import { updatedDataSelector } from '../../selectors/selected_table_data';

const styles = theme => ({
  root: {
    paddingRight: theme.spacing(1)
  },
  flex: {
    flex: 1
  },
  actions: {
    color: theme.palette.text.secondary
  },
  title: {
    flex: "0 0 auto"
  }
});

class DataTableToolbar extends React.PureComponent {
  state = {
    isDrawerOpen: false
  };

  toggleDrawer = () => {
    this.setState({ isDrawerOpen: !this.state.isDrawerOpen });
  };

  render() {
    const { classes, updatedData, headers } = this.props;

    return (
      <Toolbar className={classes.root}>
        <TemporaryDrawer
          open={this.state.isDrawerOpen}
          toggleDrawer={this.toggleDrawer}
        />
        <Typography
          component="h5"
          variant="h5"
          id="tableTitle"
          className={classes.flex}
        >
          {this.props.title}
        </Typography>

        <div>
          {updatedData.length ? (
            <Tooltip title="Export To CSV">
              <CSVLink
                headers={headers}
                data={updatedData}
                filename={"table-data.csv"}
                target="_blank"
              >
                <IconButton aria-label="Export to CSV">
                  <InsertDriveFile/>
                </IconButton>
              </CSVLink>
            </Tooltip>
          ) : null}
          <Tooltip title="Filter data">
            <IconButton
              id="open-drawer-icon"
              aria-label="Filter list"
              onClick={this.toggleDrawer}
            >
              <FilterListIcon/>
            </IconButton>
          </Tooltip>
        </div>
      </Toolbar>
    );
  }
}

DataTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  return {
    updatedData: updatedDataSelector(state),
    headers: state.statusRange.headers
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    {}
  )(DataTableToolbar)
);



// WEBPACK FOOTER //
// ./src/components/table/DataTableToolbar.js